export default __webpack_public_path__ + "static/media/icn-profile.efc68577.svg";